export default "__VITE_ASSET__D5Q2h5gE__"